import * as z from 'zod'

/**
 * Schema for breadcrumb navigation links.
 */
export const BreadcrumbSchema = z.object({
  name: z.string(),
  href: z.string(),
})

export type Breadcrumb = z.infer<typeof BreadcrumbSchema>
